<template>
  <div :class="$b()">
    <div :class="$b('column', { 'icon-wrapper': true })">
      <VisionIcon
        icon="onepc"
        size="stretch"
        colour="black"
        :class="$b('icon')"
      />
    </div>

    <div :class="$b('column')">
      <div :class="$b('heading')">
        <HighlightHeading :heading="heading" />

        <BaseHeading
          tag="p"
          size="h3"
          :class="$b('subheading')"
        >
          A simple idea with far-reaching impact.
        </BaseHeading>
      </div>

      <SecondaryLineLink
        is-button
        :class="$b('button')"
        @click="() => openModal('one-percent-for-the-planet')"
      >
        {{ $tr('Learn More') }}
      </SecondaryLineLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnePercentBanner',
  setup () {
    const modalStore = useModalStore()

    return {
      openModal (slug) {
        modalStore.OPEN_MODAL_PAGE({ slug })
      }
    }
  },
  data: () => ({
    heading: {
      highlightType: 'OnePC',
      heading: {
        value: {
          schema: 'dast',
          document: {
            type: 'root',
            children: [
              {
                type: 'paragraph',
                children: [
                  { type: 'span', value: 'We give ' },
                  { type: 'span', marks: ['highlight'], value: '1%' },
                  { type: 'span', value: ' of our revenue to the planet.' },
                ],
              },
            ],
          },
        },
      },
    },
  })
}
</script>

<style lang="postcss">
.OnePercentBanner {
  &__column--icon-wrapper {
    @apply mdMax:mb-md;
  }

  @screen md {
    @apply flex flex-wrap flex-row-reverse items-center -mx-4 overflow-hidden;

    &__column {
      @apply px-4 overflow-hidden w-1/2;

      &--icon-wrapper {
        @apply flex justify-center;
      }
    }
  }

  &__button {
    @apply block mt-[60px] mb-xxxs;

    @screen md {
      @apply mt-20;
    }
  }

  &__icon {
    width: 100px;
    height: 100px;

    @screen sm {
      width: 180px;
      height: 180px;
    }

    @screen md {
      width: 250px;
      height: 250px;
    }

    .VisionIcon__svg {
      height: 100%;
    }
  }

  &__subheading {
    @apply mt-xs;
  }
}
</style>
